// extracted by mini-css-extract-plugin
export var patreon_button = "PatreonButton-module--patreon_button--OZr0H";
export var patreon_button_icon = "PatreonButton-module--patreon_button_icon--lUM3C";